// extracted by mini-css-extract-plugin
module.exports = {"notificationsCell":"notificationsCell__JBcU7"};